/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('es6-promise').polyfill();

require('./bootstrap');

// window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));

// const app = new Vue({
//     el: '#app'
// });

$(':input[data-max-words]').on('change input', function () {
	let field = $(this),
		help  = field.next('.help-block');

	// Strip all non-word characters that aren't spaces, or a compound word.
	let safe = this.value.replace(/[^\w\s-]/g, '').replace(/(\W)-(\W)/g, '$1 $2').replace(/\s+/g, ' ').trim();

	let max   = field.data('max-words');
	let count = safe.length > 0 ? 1 : 0;

	for (let i = safe.length - 1; i >= 0; i--) {
		if (safe[i] === ' ') {
			count++;
		}
	}

	if (count > max) {
		field.parent('.form-group').addClass('has-error');
	} else {
		field.parent('.form-group').removeClass('has-error');
	}

	if (help.length === 0) {
		help = $('<span class="help-block">' + count + ' of ' + max + ' words</span>');
		field.after(help);
	} else {
		help.text(count + ' of ' + max + ' words');
	}
});

$('.js-delete-proxy').on('click', function (e) {
	e.preventDefault();

	let me = $(this);
	let target = me.data('target');
	let id = me.data('id');

	if (!confirm(me.data('prompt') || 'Are you sure you wish to delete this permanently?')) {
		return false;
	}

	// Prepend POUND for an ID selector, if no symbols used.
	if (target.match(/^\w/)) {
		target = '#' + target;
	}

	let $form = $(target);

	// Optionally override the ID in the form
	if (typeof id !== 'undefined') {
		$form.find('input[type="hidden"][name="id"]').val(id);
	}

	$form[0].submit();

	return false;
});